import { styled } from '@linaria/react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { LEFT_PADDING } from '../roadmap.type';
import { TimelineGrid } from './timeline-grid';

interface RoadmapHeaderProps {
  timelineStart: dayjs.Dayjs;
  timelineEnd: dayjs.Dayjs;
  today: dayjs.Dayjs;
  timelineWidth: string | number;
  totalDays: number;
  selectedYear: number | null;
  showTodayLine: boolean;
}

export function RoadmapHeader({
  timelineStart,
  timelineEnd,
  today,
  timelineWidth,
  totalDays,
  selectedYear,
  showTodayLine,
}: RoadmapHeaderProps) {
  const i18n = useTranslation();
  return (
    <Header>
      <HeaderLeft>
        <HeaderTitle>
          {i18n.t('strategy.tabs.goals')} & {i18n.t('strategy.tabs.outcomes')}
        </HeaderTitle>
      </HeaderLeft>
      <HeaderTimeline>
        <TimelineGrid
          timelineStart={timelineStart}
          timelineEnd={timelineEnd}
          today={today}
          timelineWidth={timelineWidth}
          totalDays={totalDays}
          showQuarters={!selectedYear}
          showTodayLine={showTodayLine}
        />
      </HeaderTimeline>
    </Header>
  );
}

// Styled components
const Header = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 2px solid var(--sky-base);
  background: linear-gradient(180deg, var(--base-white) 0%, var(--sky-lightest) 100%);
  height: 60px;
  position: sticky;
  top: 0;
  z-index: 10;
  width: 100%;
  flex-shrink: 0;
`;

const HeaderLeft = styled.div`
  width: ${LEFT_PADDING + 32}px;
  padding: 0 16px;
  flex-shrink: 0;
`;

const HeaderTitle = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: var(--ink-dark);
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const HeaderTimeline = styled.div`
  position: relative;
  height: 100%;
  flex: 1;
  border-left: 1px solid var(--sky-light);
  border-right: 1px solid var(--sky-light);
  overflow: hidden;
`;
